<template>
  <div class="ys-welcome">
    <div class="ys-welcome-main">
      <img :src="logoImg" alt="카이온" class="ys-logo-wordmark ys-logo-wordmark--lg" />
      <p class="ys-welcome-sub">{{ fnaMode ? '회계담당·기관 영수증 관리' : '장기요양 업무 앱' }}</p>

      <div v-if="mustInstall" class="ys-install-card">
        <p class="ys-install-state" :class="`is-${installPresence}`">{{ installPresenceLabel }}</p>
        <p class="ys-install-title">{{ installPresence === 'installed' ? '앱 실행' : '앱 설치' }}</p>
        <p class="ys-install-desc">{{ installLead }}</p>
        <ol v-if="showSteps && installPresence !== 'installed' && installGuide?.steps?.length" class="ys-install-steps">
          <li v-for="(step, i) in installGuide.steps" :key="i">{{ step }}</li>
        </ol>
        <button
          v-if="installPresence !== 'installed'"
          type="button"
          class="ys-btn ys-btn-primary ys-install-btn"
          :disabled="installPresence === 'checking' || installPresence === 'installing'"
          @click="onInstallClick"
        >
          {{ installPresence === 'installing' ? '설치 중' : '앱 설치' }}
        </button>
      </div>

      <div v-else-if="showInstallCta" class="ys-install-card">
        <p class="ys-install-kicker">앱 설치</p>
        <p class="ys-install-title">앱 설치</p>
        <p class="ys-install-desc">
          Chrome · Safari · 삼성 인터넷 · Edge 등 사용 중인 브라우저에서 홈 화면에 추가할 수 있어요.
        </p>
        <ol v-if="installGuide?.steps?.length" class="ys-install-steps">
          <li v-for="(step, i) in installGuide.steps.slice(0, 3)" :key="i">{{ step }}</li>
        </ol>
        <button type="button" class="ys-btn ys-btn-primary ys-install-btn" @click="onInstallClick">
          앱 설치
        </button>
      </div>
    </div>

    <div v-if="!mustInstall" class="ys-welcome-actions">
      <button type="button" class="ys-btn ys-btn-primary" @click="$router.push('/login')">
        로그인
      </button>
      <button
        v-if="!fnaMode"
        type="button"
        class="ys-btn ys-btn-ghost"
        @click="$router.push('/signup')"
      >
        회원가입
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import logoImg from '@/assets/images/brand/caion-logo-clear.png'
import { isFnaFlavor } from '@/config/appFlavor'
import {
  captureInstallSourceFromUrl,
  installedAppName,
  isStandaloneDisplay,
  promptInstall,
  usePwaInstall,
} from '@/composables/usePwaInstall'

const fnaMode = computed(() => isFnaFlavor())

const {
  isInstalled,
  installGuide,
  installPresence,
  installPresenceLabel,
  refreshInstalled,
} = usePwaInstall()
const showSteps = ref(false)

const mustInstall = computed(() => !fnaMode.value && !isStandaloneDisplay())
const showInstallCta = computed(() => !isInstalled.value)
const installLead = computed(() => {
  if (installPresence.value === 'installed') {
    return `홈 화면의 ${installedAppName()} 아이콘을 눌러 앱을 실행하세요.`
  }
  if (installPresence.value === 'installing') return '설치가 끝나면 이 화면이 설치됨으로 바뀝니다.'
  if (installPresence.value === 'unknown') {
    return '이 브라우저에서는 설치됐는지 확인하지 못합니다. 홈 화면에 아이콘이 있으면 그 아이콘으로 여세요.'
  }
  return '카이온은 설치한 앱에서만 사용할 수 있습니다.'
})

const onInstallClick = async () => {
  const result = await promptInstall(mustInstall.value ? { sheet: false } : undefined)
  if (result === 'manual' || result === 'external') showSteps.value = true
}

onMounted(() => {
  captureInstallSourceFromUrl()
  refreshInstalled()
})
</script>
